import Filecoin from "./../../images/moralis-filecoin.png";
import Google from "./../../images/moralis-google.png";
import Chainlink from "./../../images/chainlink-hackathon.png";
import BTCOlympics from "./../../images/btc-hackathon.png";
import FLOWHack from "./../../images/flow-hack.png";
export type Hackathon = {
  name: string,
  hackathonUrl: string,
  description: string,
  image: any,
  url: string,
  project: string,
  prizes: { name: string }[],
}

export const hackathons: Hackathon[] = [
  {
    name: "BITCOIN OLYMPICS HACKATHON",
    hackathonUrl: "https://btcstartuplab.com/BitcoinOlympics",
    description: "Where AI meets Blockchain to revolutionize the NFT landscape. Discover, create, and trade AI-generated digital assets securely on the Bitcoin and Rootstock chains. ",
    image: BTCOlympics,
    url: "https://devpost.com/software/nft-origin",
    project: "AI NFTify Marketplace",
    prizes: []
  },
  {
    name: "Flow Hackathon Season 2",
    hackathonUrl: "https://flow.com/hackathon",
    description: "Flow network's crypto wallets have two major challenges: user complexity with extension and mobile wallets, and reliance on centralized solutions like Dapper and Blocto. Our solution, AANodes and AllAccess Wallet, inspired by Torus and the WAX Cloud Wallet, aims to simplify usability and promote decentralization on Flow.",
    image: FLOWHack,
    url: "https://devfolio.co/projects/allaccess-wallet-5cc9",
    project: "AllAccess Wallet",
    prizes: []
  },
];